import { TAudioType, TRecording, TUserGroup } from '../../../store/models/types';
import { EUserGroupType } from '../../../store/general/types';

export interface IPastLesson {
  groupId: number;
  audio: TRecording;
}

export const PAST_LESSONS_LIMIT = 10;

export interface IStudent {
  id: number;
  name: string;
}

// The Daily participant fields this needs; userData.userId is set by every client at join, as a string.
export interface IRoomParticipant {
  user_name?: string;
  userData?: unknown;
}

// Students in the room from the remote Daily sessions: my own stale session (left over after a
// refresh) and duplicate sessions of one student are dropped.
export function getStudents(participants: IRoomParticipant[], myId: number): IStudent[] {
  const seen = new Set<number>();
  const students: IStudent[] = [];
  participants.forEach(p => {
    const id = Number((p.userData as { userId?: string } | undefined)?.userId);
    if (!p.userData || Number.isNaN(id) || id === myId || seen.has(id)) return;
    seen.add(id);
    students.push({ id, name: p.user_name || 'Student' });
  });
  return students;
}

// The newest recordings every student in the room took part in. Groups and audios come from the
// store as the home page shows them; the current call and "Unprocessed call" placeholders are left out.
export function getPastLessons(
  groups: TUserGroup[],
  studentIds: number[],
  currentRoomId: string | null,
): IPastLesson[] {
  if (!studentIds.length || studentIds.some(id => Number.isNaN(id))) return [];

  const lessons: IPastLesson[] = [];
  groups.forEach(g => {
    if (g.type !== EUserGroupType.CONFERENCE) return;
    (g.audios as TRecording[] || []).forEach(audio => {
      if (audio.type === TAudioType.CONFERENCE) return;
      if (currentRoomId && (audio.roomName === currentRoomId || audio.audioS3FilePath?.includes(currentRoomId))) return;
      const participants = audio.participants || [];
      if (!studentIds.every(id => participants.some(p => p.id === id))) return;
      lessons.push({ groupId: g.id, audio });
    });
  });

  return lessons
    .sort((a, b) => b.audio.createdAt.localeCompare(a.audio.createdAt))
    .slice(0, PAST_LESSONS_LIMIT);
}
